import dayjs from 'dayjs';
import { useAppSelector } from '../../../../common/hooks';
import { PDFImportantInformation } from '../../../../components/molecules';
import ReviewPlanDetails from '../../../../containers/review-plan-details';
import PDFLandingPageNewCover from '../PDFLanding/PDFLandingNewCover';
import { styled } from '@mui/material/styles';

const GeneratedPlanPDF = () => {
    const { user } = useAppSelector((state) => state?.auth);
    const { globalConfig } = useAppSelector((state) => state?.global);
    const adviceGoals = useAppSelector((state) => state?.adviceGoals);
    const adviceClient = useAppSelector((state) => state?.adviceClient);
    const { keyValueRequest } = useAppSelector((state) => state?.advisorConsole);
    const { _id: selectedClientID } = adviceClient || {};

    const selectedClient = keyValueRequest[selectedClientID];

    const getValidDate = (value: string): string => {
        return dayjs(value).isValid() ? dayjs(value).format('MM/DD/YYYY') : '-';
    };
    const planCreationDate = getValidDate(selectedClient?.global?.planCreationDate);
    const lastUpdateDate = getValidDate(selectedClient?.global?.lastUpdateDate);
    // 4 pages in PDF per goal + 1 page per unrealistic goal + 1 for last page
    const totalPagesForPDF =
        adviceGoals?.response.reduce(
            (acc, goal) => (goal?.response?.body?.analysisReport?.isGoalRealistic ? acc + 4 : acc + 1),
            0
        ) + 1;
    const PaddedWrapper = styled('div')(() => ({
        padding: '0px 25px 5px 25px'
    }));

    return (
        <>
            <PDFLandingPageNewCover
                globalConfig={globalConfig}
                proposalCreatedBy={user?.loggedInUsername}
                proposalCreatedFor={`${adviceClient?.clientFirstName} ${adviceClient?.clientLastName}`}
                proposalPlanCreationDate={planCreationDate}
                proposalPlanLastUpdateDate={lastUpdateDate}
            />
            <PaddedWrapper>
                <ReviewPlanDetails isPDF />
                <PDFImportantInformation
                    advisorEmail={user?.userEmail}
                    advisorName={user?.loggedInUsername}
                    totalPages={totalPagesForPDF}
                />
            </PaddedWrapper>
        </>
    );
};

export default GeneratedPlanPDF;
